<template>
  <li>
    <strong>{{ itemKey }}:</strong>
    <span v-if="!isObject(itemValue)">{{ itemValue === null ? "N/A" : itemValue }}</span>
    <ul v-else>

      <JsonItem
          v-for="(nestedValue, nestedKey) in itemValue"
          :key="nestedKey"
          :itemKey="nestedKey"
          :itemValue="nestedValue"
      />
    </ul>
  </li>
</template>

<script>

export default {
  name: 'JsonItem',
  props: {
    itemKey: {
      type: String,
      required: true
    },
    itemValue: {
      required: true
    }
  },

  setup() {

    const isObject = value => {
      return typeof value === 'object'
    }

    return {
      isObject
    }
  }
};
</script>